import React, { useEffect, useState } from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../../../core/common/textFields/TextField';
import { svgIcons } from '../../../../../../style/fonts/SvgIcons';
import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DateField from '../../../../../../core/common/textFields/DateField';
import { useGetAllAccountsQuery, useLazyGetContactsByAccountIdQuery } from '../../../../../../services/EndPointsApis';



const GeneralTabCol2 = ({ isReadOnly, formik, leadsInquiryLookups, getdefaultLookups }: any) => {

    //Accounts APi
    const { data: allAccounts, refetch: allAccountsRefetch } = useGetAllAccountsQuery('');
    //Get Contact detaisl by account 

    const [triggerContactsData, { data: getContactsData, }] = useLazyGetContactsByAccountIdQuery();

    const [selectedRetainerDate, setSelectedRetainerDate] = useState<Date | null>(null);

    dayjs.extend(customParseFormat);
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const handleRetainerDateChange = (date: Dayjs | null) => {
        // setSelectedRetainerDate(date);
        formik.setFieldValue('retainerCollectionDate', date)
    };
    const handleaccount = (selectedOption: any) => {
        formik.setFieldValue('lst_Account.id', selectedOption.value);
        formik.setFieldValue('lst_Account.value', selectedOption.label);

        if (selectedOption.value !== 0) {
            triggerContactsData({ Id: selectedOption.value })
        }
    }
    useEffect(() => {
        if (getContactsData) {
            formik.setFieldValue('lst_Account.id', getContactsData?.result[0]?.lst_Account.id);
            formik.setFieldValue('lst_Account.value', getContactsData?.result[0]?.lst_Account.value);
            formik.setFieldValue('mobilePhone', getContactsData?.result[0]?.contactNo)
            formik.setFieldValue('emailAddress', getContactsData?.result[0]?.email)
            formik.setFieldValue('mianPhone', getContactsData?.result[0]?.mianPhone)
            formik.setFieldValue('addressLine1', getContactsData?.result[0]?.addressLine1)
            formik.setFieldValue('addressLine2', getContactsData?.result[0]?.addressLine2)
            formik.setFieldValue('addressLine3', getContactsData?.result[0]?.addressLine3)
            formik.setFieldValue('addressCity', getContactsData?.result[0]?.city)
            formik.setFieldValue('addressStateOrProvince', getContactsData?.result[0]?.AddressStateOrProvince)
            formik.setFieldValue('addressPostalCode', getContactsData?.result[0]?.AddressPostalCode)
            formik.setFieldValue('country', getContactsData?.result?.state)
        }
    }, [getContactsData])

    return (
        <>
            <div className='card'>
                <div className='card-body'>
                    {/* <div className="col-md-12">
                            <div className="form-wrap">
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    // options={allAccounts?.result?.data?.map((option: any) => ({
                                    //     label: option?.accountName,
                                    //     value: option?.accountId
                                    // }))}
                                    options={[
                                        { label: "Select Option", value: 0 },
                                        ...(allAccounts?.result?.data?.map((option: any) => ({
                                            label: option?.accountName,
                                            value: option?.accountId
                                        })) || [])
                                    ]}
                                    value={
                                        formik.values?.lst_Account?.id
                                            ? {
                                                value: formik.values?.lst_Account?.id,
                                                label: formik.values?.lst_Account?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(value: any) => handleaccount(value)}
                                />
                            </div>
                        </div> */}

                    <h6 className='mb-2 mt-2'>
                        Customer Detail
                    </h6>
                    <>
                        <TextField
                            label="Primary Contact"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={formik.values.lst_Contact?.value}
                            // onChange={(e: any) => { formik.setFieldValue('mobilePhone', e.target.value) }}
                            // {...formik.getFieldProps("lst_Contact?.value")}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Account"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={formik.values.lst_Account?.value}
                            // onChange={(e: any) => { formik.setFieldValue('mobilePhone', e.target.value) }}
                            // {...formik.getFieldProps("lst_Contact?.value")}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Email"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={formik.values.emailAddress}
                            // {...formik.getFieldProps("emailAddress")}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Main Phone"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={getContactsData?.result[0]?.cellPhone || formik.values.mainPhone}
                            // onChange={(selectedOption: any) => { formik.setFieldValue('mianPhone', getContactsData?.result[0]?.mianPhone) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: Street 1"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={getContactsData?.result[0]?.addressLine1 || formik.values.addressLine1}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressLine1', getContactsData?.result[0]?.addressLine1) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: Street 2"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={getContactsData?.result[0]?.addressLine2 || formik.values.addressLine2}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressLine2', getContactsData?.result[0]?.addressLine2) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: Street 3"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={getContactsData?.result[0]?.addressLine3 || formik.values.addressLine3}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressLine3', getContactsData?.result[0]?.addressLine3) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: City"
                            type="text"
                            icon={svgIcons.LockIcon}
                            value={getContactsData?.result[0]?.city || formik.values.addressCity}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressCity', getContactsData?.result[0]?.city) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: State/Province"
                            type="text"
                            icon={svgIcons.LockIcon}
                            // {...formik.getFieldProps("AddressStateOrProvince")}
                            value={getContactsData?.result[0]?.state || formik.values.addressStateOrProvince}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressStateOrProvince', getContactsData?.result[0]?.AddressStateOrProvince) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: ZIP/Postal Code"
                            type="text"
                            icon={svgIcons.LockIcon}
                            // {...formik.getFieldProps("AddressPostalCode")}
                            value={getContactsData?.result[0]?.zipCode || formik.values.addressPostalCode}
                            onChange={(selectedOption: any) => { formik.setFieldValue('addressPostalCode', getContactsData?.result[0]?.AddressPostalCode) }}
                            disabled
                        />
                    </>
                    <>
                        <TextField
                            label="Address 1: Country/Region"
                            type="text"
                            icon={svgIcons.LockIcon}
                            // {...formik.getFieldProps("country")}
                            value={getContactsData?.result[0]?.state || formik.values.country}
                            onChange={(selectedOption: any) => { formik.setFieldValue('country', getContactsData?.result?.state) }}
                            disabled
                        />
                    </>
                    <>
                        {/* <TextField
                            label="Contact"
                            type="text"
                            icon={svgIcons.LockIcon}
                            {...formik.getFieldProps("contact")}
                            disabled
                        /> */}
                    </>
                    <>
                        <TextField
                            label="Lead Taker"
                            type="text"
                            {...formik.getFieldProps("lst_LeadTaker.value")}
                            disabled={isReadOnly}
                        />
                    </>
                    <>
                        <TextField
                            label="Sales Consultant"
                            type="text"
                            {...formik.getFieldProps("lst_SalesConsultant.value")}
                            disabled={isReadOnly}
                        />
                    </>
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-0'>
                        PDM Questions
                    </h5>
                    <>
                        <TextField
                            label="Why did you call us now?"
                            type="text"
                            {...formik.getFieldProps("question1")}
                            disabled={isReadOnly}
                        />
                    </>
                    <>
                        <TextField
                            label="What would prevent you from doing this project?"
                            type="text"
                            {...formik.getFieldProps("question2")}
                            disabled={isReadOnly}
                        />
                    </>
                    <>
                        <TextField
                            label="Why did you not move?"
                            type="text"
                            {...formik.getFieldProps("question3")}
                            disabled={isReadOnly}
                        />
                    </>
                    <>
                        <TextField
                            label="Why did you buy this house?"
                            type="text"
                            {...formik.getFieldProps("question4")}
                            disabled={isReadOnly}
                        />
                    </>
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-0'>
                        Retainer
                    </h5>
                    <div className="col-md-12">
                        <label className='input-label'>Retainer Status</label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_RetainerStatus
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_RetainerStatus?.id
                                    ? {
                                        value: formik.values?.lst_RetainerStatus?.id,
                                        label: formik.values?.lst_RetainerStatus?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_RetainerStatus.id', selectedOption.value);
                                formik.setFieldValue('lst_RetainerStatus.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Retainer Payment Type </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_RetainerPaymentType
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_RetainerPaymentType?.id
                                    ? {
                                        value: formik.values?.lst_RetainerPaymentType?.id,
                                        label: formik.values?.lst_RetainerPaymentType?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_RetainerPaymentType.id', selectedOption.value);
                                formik.setFieldValue('lst_RetainerPaymentType.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Retainer Type </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_RetainerType
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_RetainerType?.id
                                    ? {
                                        value: formik.values?.lst_RetainerType?.id,
                                        label: formik.values?.lst_RetainerType?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_RetainerType.id', selectedOption.value);
                                formik.setFieldValue('lst_RetainerType.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Retainer Collection Date</label>
                        <div className="form-wrap icon-form">
                            <span className="form-icon">
                                <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                                className="form-control datetimepicker deals-details "
                                onChange={handleRetainerDateChange}
                                disabled={isReadOnly}
                                value={formik.values?.retainerCollectionDate ? dayjs(formik.values?.retainerCollectionDate, 'YYYY-MM-DD') : null}

                            />
                        </div>
                    </div>
                    <>
                        <TextField
                            label="Retainer Asked Amount"
                            type="number"
                            {...formik.getFieldProps("retainerAskedAmount")}
                            disabled={isReadOnly}
                            icon2={svgIcons.dollarIcon}

                        />
                    </>
                    <>
                        <TextField
                            label="Retainer Amount Collected"
                            type="number"
                            {...formik.getFieldProps("retainerAmountCollected")}
                            disabled={isReadOnly}
                            icon2={svgIcons.dollarIcon}

                        />
                    </>

                </div>
            </div>

        </>
    )
}

export default GeneralTabCol2